import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, Inputs, Row, ActionButton } from "2g-form";
import { required } from "2g-validators-common";

import TypyZdrojuOnlySwitch from "b2b/components/form-switches/TypyZdrojuOnlySwitch";
import ZdrojEditaceWidgetTitleDescription from "./ZdrojEditaceWidgetTitleDescription";
import useZdrojEditaceWidget from "./useZdrojEditaceWidget";
import useMessages from "./i18n/useMessages";

const requiredValidator = required();

export function ZdrojEditaceWidget({ zdroj, loading }) {
  const { buttonDelete, buttonSubmit, buttonCancel } = useMessages();
  const {
    formModuleKey,
    onSubmit,
    onCancel,
    onDelete,
    maxPocetPozadavkuDisabled
  } = useZdrojEditaceWidget({
    zdroj
  });
  return (
    <Widget
      collapsable={false}
      title={
        <ZdrojEditaceWidgetTitleDescription zdroj={zdroj} loading={loading} />
      }
    >
      <Form moduleKey={formModuleKey} onSubmit={onSubmit} disabled={loading}>
        <Row styled>
          <Field
            component={Inputs.Input}
            path="nazevCs"
            label="b2b.zdroj-editace-form.field.nazevCs.label"
            validators={requiredValidator}
            required
          />
          <Field
            component={Inputs.Input}
            path="nazevEn"
            label="b2b.zdroj-editace-form.field.nazevEn.label"
            validators={requiredValidator}
            required
          />
        </Row>
        <Row styled>
          <Field
            component={Inputs.TextArea}
            path="popisCs"
            label="b2b.zdroj-editace-form.field.popisCs.label"
          />
          <Field
            component={Inputs.TextArea}
            path="popisEn"
            label="b2b.zdroj-editace-form.field.popisEn.label"
          />
        </Row>
        <Row>
          <div className="b2b-Form-checboxGroup">
            <Field
              component={Inputs.Checkbox}
              path="exkluzivita"
              label="b2b.zdroj-editace-form.field.exkluzivita.label"
              light
            />
            <Field
              component={Inputs.Checkbox}
              path="pozadavekSmena"
              label="b2b.zdroj-editace-form.field.pozadavekSmena.label"
              light
            />
          </div>
          <Field
            disabled={maxPocetPozadavkuDisabled}
            component={Inputs.Input}
            path="maxPocetPozadavku"
            label="b2b.zdroj-editace-form.field.maxPocetPozadavku.label"
            validators={requiredValidator}
            required
          />
        </Row>
        <Row>
          <TypyZdrojuOnlySwitch validators={requiredValidator} required />
        </Row>
        <ButtonsSet position="right">
          {zdroj ? (
            <ActionButton button={Buttons.Danger} onClick={onDelete} inverse>
              {buttonDelete()}
            </ActionButton>
          ) : undefined}
          <ActionButton button={Buttons.Primary} validate submit inverse>
            {buttonSubmit()}
          </ActionButton>
          <ActionButton button={Buttons.Default} onClick={onCancel}>
            {buttonCancel()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

ZdrojEditaceWidget.propTypes = { zdroj: T.object, loading: T.bool };

export default React.memo(ZdrojEditaceWidget);
